import '@babel/polyfill';

// Core
import { getToken } from './core/Api';

// Utilities
import autocompleteForMask from './utilities/autocompleteForMask';
import defaultValidationTexts from './utilities/defaultValidationTexts';
import unobtrusiveValidation from './utilities/unobtrusiveValidation';
import multipleIDs from './utilities/multipleIDs';
import successMessage from './utilities/successMessage';
import revalidate from './utilities/revalidate';
import gdlClickEvents from './utilities/gdlClickEvents';
import dontAllowBackButton from './utilities/dontAllowBackButton';
import dotSeperation from './utilities/dotSeperation';
import quotationmarks from './utilities/quotationmarks';
import maxLengthNumberInput from './utilities/maxLengthNumberInput';
import preventSubmitOnEnter from './utilities/preventSubmitOnEnter';
import urlParams from './utilities/urlParams';
import windowFunctions from './utilities/windowFunctions';

// Components
import Accordion from './components/accordion';
import Address from './components/address';
import birthdate from './components/birthdate';
import carousel from './components/carousel';
import countdown from './components/countdown';
import day from './components/day';
import expandable from './components/expandable';
import greeting from './components/greeting';
import Iban from './components/iban';
import modalMain from './components/modalMain';
import month from './components/month';
import optins from './components/optins';
import PageProgress from './components/pageProgress';
import permit from './components/permit';
import remove from './components/remove';
import show from './components/show';
import state from './components/state';
import tooltips from './components/tooltips';
import value from './components/value';
import virtualpaging from './components/virtualpaging';
import waitpage from './components/waitpage';
import Wincode from './components/wincode';
import benicode from './components/benicode';

class App {
  constructor() {
    this.globals = {
      token: getToken(),
    };
    this.token = this.globals.token;
  }

  init() {
    // Utilities
    autocompleteForMask();
    defaultValidationTexts();
    unobtrusiveValidation();
    multipleIDs();
    successMessage();
    revalidate();
    gdlClickEvents();
    dontAllowBackButton();
    dotSeperation();
    quotationmarks();
    maxLengthNumberInput();
    preventSubmitOnEnter();
    urlParams();
    windowFunctions();

    // Components
    Accordion();
    new Address(); // eslint-disable-line no-new
    birthdate();
    carousel();
    countdown();
    day();
    expandable();
    greeting();
    modalMain();
    month();
    optins();
    new PageProgress().init(); // eslint-disable-line no-new
    permit();
    remove();
    show();
    state();
    tooltips();
    value();
    virtualpaging();
    waitpage();
    benicode();

    // Preferred way of initiating components
    new Iban(this.globals).init();
    new Wincode(this.globals).init();
  }
}

new App().init();
